var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-select-color-dropdown-content" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          key: option.value,
          staticClass: "custom-select-color-dropdown-content__option",
          on: {
            click: function($event) {
              return _vm.toggle(option)
            }
          }
        },
        [
          _c("color-select-option", {
            staticClass: "custom-select-color-dropdown-content__color",
            attrs: { color: option.hex, "is-selected": _vm.isSelected(option) }
          }),
          _c(
            "div",
            { staticClass: "custom-select-color-dropdown-content__label" },
            [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }